<template>
	<div>
		<v-dialog v-model="dialog_richtext" scrollable fullscreen persistent :overlay="false" v-if="dialog_richtext" max-width="500px" no-click-animation transition="slide-y-transition">
	    	<v-card class="print-field-content" flat style="padding-top:68px !important;padding-bottom:68px !important;">
                <v-toolbar flat fixed class="main_toolbar">
                    <v-toolbar-side-icon @click="closeDialogWeb"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                    <v-toolbar-title>Content</v-toolbar-title>
                    <!-- <v-btn flat icon color="primary" @click="fn_saveContent"><v-icon>done</v-icon></v-btn> -->
                </v-toolbar>
                <quill-editor class="hasFoooterBtn" ref="myTextEditor"
                    v-model="content"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)">
                    <div id="toolbar" slot="toolbar">
                        <!-- Add a bold button -->
                        <button class="ql-bold">Bold</button>
                        <button class="ql-italic">Italic</button>
                        <button class="ql-underline">ql-underline</button>
                        <button class="ql-strike">Italic</button>
                        <!-- Add ordered/bullet list -->
                        <button class="ql-list" value="ordered">ql-list</button>
                        <button class="ql-list" value="bullet">ql-list</button>

                        <!-- You can also add your own -->
                        <!-- <button id="custom-button" @click="fn_checkPermission" style="padding:0"><v-icon>insert_photo</v-icon></button> -->
                        <!-- <button id="custom-button" @click="fn_pickSignature('image_content')" style="padding:0"><v-icon>insert_photo</v-icon></button> -->

                        <!-- Add font size dropdown -->
                        <select class="ql-size">
                          <option value="small"></option>
                          <!-- Note a missing, thus falsy value, is used to reset to default -->
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>

                        
                    </div>
                </quill-editor>
                <!-- <v-btn flat color="primary" style="position:fixed;bottom:42px;background:#fff;right:0" nomargin @click="fn_previewContent"><v-icon color="primary" left>visibility</v-icon>Preview</v-btn> -->

                <div white-background full-width nopadding style="position:fixed;bottom:0;">
                    <v-layout row wrap style="background:#ddd;">
                        <v-flex xs12 sm12 md12>
                            <v-btn style="height:48px !important" color="primary" nomargin block no-round-borders noshadow @click="fn_saveContent">Done</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
//import { position, offset } from 'caret-pos';

export default{
    props:['saveContent'],
	data(){	
		return{
			dialog_richtext: false,
            content:'',
			editorOption: {
              modules: {
                toolbar: '#toolbar'
              }
            },
            // keywords:[
            //         {"name":"Business Fields", "items":[{"title":"Name", "keyword":"{{BusinessName}}"},{"title":"Address", "keyword":"{{BusinessAddress}}"},{"title":"State", "keyword":"{{BusinessState}}"}]}
            //     ]
		}
	},
	components: {
        quillEditor
    },
	methods: {
		openDialogWeb: function () {	
			this.dialog_richtext = true;
		},
		closeDialogWeb: function () {
			this.dialog_richtext = false;
		},
        fn_saveContent: function(){
            this.saveContent('bottom_note');
        },
		onEditorBlur(editor) {
            console.log('editor blur', editor);
        },
        onEditorFocus(editor) {
            console.log('editor focus', editor);
            console.log(editor.clientX);
            //this.getCaretPosition();
        },
        onEditorReady(editor) {
            console.log('editor ready', editor)
        },
	}
}
</script>

<style>
    .print-field-content .quill-editor{
        padding-bottom: 100px;
        background-color:#fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_richtext.vue